<template>
  <nav class="navbar-cust" @mouseleave="disableHover">
    <div id="navbar-collapsed" class="navbar-collapsed">
      <div class="navbar-brand py-3 px-2">
        <a href="" class="text-app">MT</a>
      </div>
      <div class="menu-button-mobile py-3 px-4 h5" @click="toggleHover()">
        <span v-if="!getHover">Menu</span>
        <span v-else>Close</span>
      </div>
      <div class="navigation" @mouseover="enableHover()">
        <a href="" id="home" @click.prevent="emitChange('home')" :class="getClass('home')">
          <HomeIcon></HomeIcon>
        </a>
        <a href="/about" id="about" @click.prevent="emitChange('about')" :class="getClass('about')">
          <HelpCircleIcon></HelpCircleIcon>
        </a>
      </div>
      <div class="navbar-bottom py-3 px-3">
      </div>
    </div>
    <div id="navbar-expanded" class="navbar-expanded" v-if="getHover">
      <div id="navbar-expanded-navigation" class="navigation text-left">
        <a href="" id="home" @click.prevent="emitChange('home')" :class="getClass('home')">
          <span>Home</span>
        </a>
        <a href="/about" id="about" @click.prevent="emitChange('about')" :class="getClass('about')">
          <span>About</span>
        </a>
      </div>
    </div>
    <div id="navbar-bottom" class="navbar-bottom" @click="sendThemeChangeRequest()">
        <MoonIcon v-if="isDarkIcon"></MoonIcon>
        <SunIcon v-else color="#FFCA28"></SunIcon>
    </div>
  </nav>
</template>

<script>
import {HomeIcon, HelpCircleIcon, MoonIcon, SunIcon} from 'vue-feather-icons';

export default {
  name: "Navbar",
  components: {
    HomeIcon,
    HelpCircleIcon,
    MoonIcon,
    SunIcon
  },
  props: {
    highlight: {
      type: String,
      default: "home",
    },
  },
  data: () => {
    return {
      isHovered: false,
      showDark: true,
    }
  },
  methods: {
    highlightCurrentPageIcon() {
      // Add the active class to the passed current id.
      document.getElementById(this.highlight).classList.add("active");
    },
    emitChange(clickedWhere) {
      this.$emit("nav-click", clickedWhere);
      this.disableHover();
      return false;
    },
    getClass(callingElement) {
      if (this.highlight == callingElement) return "active";
      else return "";
    },
    enableHover() {
      if (this.isHovered) return;
      this.isHovered = true;

      // Styles for mobile devices
      if (window.innerWidth <= 468) {
        document.getElementById('navbar-bottom').style.display = "block";
      }
    },
    disableHover() {
      if (!this.isHovered) return;
      this.isHovered = false;

      // Styles for mobile devices
      if (window.innerWidth <= 468) {
        document.getElementById('navbar-bottom').style.display = "none";
      }
    },
    toggleHover() {
      if (this.isHovered) this.disableHover();
      else this.enableHover();
    },
    animateSpan() {
      if (!this.isHovered) return;

      document.getElementById("navbar-expanded").getElementsByTagName("span").forEach((el, index) => {
        el.classList.add('fadeInUp');
        el.style.animationDelay = `${0.3 + index * 0.1}s`
      })
    },
    toggleThemeIcon() {
      this.showDark = !this.showDark;
    },
    sendThemeChangeRequest() {
      this.$emit('theme-change', this.showDark);
    }
  },
  computed: {
    getHover() {
      return this.isHovered;
    },
    isDarkIcon() {
      return this.showDark;
    }
  },
  updated() {
    this.animateSpan();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$background: lighten(#EEEEEE, 3);
$primary-color: #5C6BC0;

.navbar-cust {
  position: fixed;
  left: 0;
  height: 100%;
  z-index: 2;
  background: $background;
  display: flex;

  .menu-button-mobile {
    display: none;
  }

  .navbar-expanded {
    background: $background;
    width: 0;
    animation-name: expandRight;
    animation-duration: .3s;
    animation-fill-mode: both;
    overflow: hidden;

    .navigation {
      margin-top: 65px;

      a {
        padding-left: .75rem;

        span {
          padding: 3px;
          border-radius: 3px;
        }

          &:hover {
          background: darken($background, 5);
          transition: .5s ease;
          text-decoration: none;
        }
      }

      .active {
        span {
          background: lighten($primary-color, 35);
        }
      }
    }
  }

  @keyframes expandRight {
    0% {
      width: 0;
      opacity: 0;
    }
    100% {
      width: 10.5rem;
      opacity: 1;
    }
  }

  .navbar-collapsed {
    background: $background;
    width: 6rem;
    height: 100%;
  }

  .navigation {
    margin: 10px 0;
    text-align: center;

    a {
      font-size: 16px;
      padding: 20px 0;
      display: block;
      color: darken($background, 40);
    }

    .active {
        color: $primary-color;
      }
  }

  .navbar-brand {
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    width: 100%;

    a {
      &:hover {
        text-decoration: none;
        color: darken(#E91E63, 5);
      }
    }
  }

  .navbar-bottom {
    position: absolute;
    bottom: 0;
    width: 6rem;
    padding: 20px 0;
    text-align: center;

    &:hover {
      background: darken($background, 4);
    }
  }
}

@media only screen and (max-width: 468px) {
  .navbar-cust {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100vw;

    .menu-button-mobile {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
    }

    .navbar-collapsed {
      div {
        display: inline-block;
      }

      .navigation {
        display: none;
      }
    }

    .navbar-expanded {
      width: 100%;
      position: absolute;
      height: 100vh;
      left: 0;
      z-index: -2;
      animation-name: none;
      .navigation {

        a {
          font-size: 30px;

          span {
            padding: 10px 20px;
          }
        }
      }
    }
    .navbar-bottom {
      display: none;
      top: 240px;
    }
  }
}

</style>
